export enum ImportSteps {
  import = 0,
  mappingField = 1,
  dataCleaning = 2,
  tagsAndGroup = 3,
  finish = 4,
}
